import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface LeaseLiabilityClassicInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function LeaseLiabilityClassicInternalControls({ onBack, setActiveSection, controlsListSection }: LeaseLiabilityClassicInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Lease Liability"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
